var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-questions"},[_c('PCFaq',{staticClass:"pc",attrs:{"data":_vm.data}}),_c('PadFaq',{staticClass:"pad",attrs:{"data":_vm.data}}),_c('MobileFaq',{staticClass:"mobile",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }